import request from "@/utils/request";
import ENDPOINT from "@/config/endpoint";

async function list(params) {
  return await request({
    url: ENDPOINT.CONTRACTS,
    method: "get",
    params,
  });
}

async function fetchById(id) {
  return await request({
    url: `${ENDPOINT.CONTRACTS}/${id}`,
    method: "get",
  });
}

async function create(data) {
  return await request({
    url: ENDPOINT.CONTRACTS,
    method: "post",
    data,
  });
}

async function update(data) {
  return await request({
    url: `${ENDPOINT.CONTRACTS}/${data.id}`,
    method: "patch",
    data,
  });
}

async function remove(data) {
  return await request({
    url: `${ENDPOINT.CONTRACTS}/${data.id}`,
    method: "delete",
    data,
  });
}

export default {
  list,
  fetchById,
  create,
  update,
  remove,
};
